import React from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { Button } from "@mui/material";
import { makeStyles } from "@mui/styles";

const ChooseButton = ({ node }) => {
  const {
    text,
    backgroundColor,
    hoverBackgroundColor,
    textColor,
    hoverTextColor,
  } = node;

  const useStyles = makeStyles({
    flexGrow: {
      flex: "1",
    },
    button: {
      backgroundColor: backgroundColor,
      color: textColor,
      fontWeight: 700,
      marginLeft: "10px",
      marginRight: "10px",
      marginTop: "10px",
      fontSize: "1.6vmax",
      "&:hover": {
        backgroundColor: hoverBackgroundColor,
        color: hoverTextColor,
      },
      "&:focus": {
        backgroundColor: hoverBackgroundColor,
        color: hoverTextColor,
      },
    },
  });

  const classes = useStyles();

  return (
    <Button variant="contained" className={classes.button}>
      {text}
    </Button>
  );
};

export default ChooseButton;
